import React, { Component } from 'react';
import { Input, Col } from 'antd';
import Flexbox from 'flexbox-react';
import { injectIntl } from 'react-intl';
import messages from './messages';
const InputGroup = Input.Group;

class TypeDimensions extends Component{
	constructor(props) {
		super(props);
		this.state = {
			width: '',
			height: '',
			length: '',
			maxLength: '4',
			widthError: false,
			heightError: false,
			lengthError: false,
			message: props.intl.formatMessage(messages.errorMessage),
		};
	}
	
	validate = (value) => {
		const reg = /^-?(0|[1-9][0-9]*)?$/;
		return ((!isNaN(value) && reg.test(value)) || value === '' || value === '-');
	};
	side = (value, valueName) => {
		const typeError = `${valueName}Error`;
		if (value >= 20) {
			this.setState({ [typeError]: false });
		} else if (value === '') {
			this.setState({ [typeError]: false });
		}
		else {
			this.setState({ [typeError]: true });
		}
	};
	onChange = (e) => {
		const { value } = e.target;
		const valueName = e.target.id;
		
		if (this.validate(value)) {
			this.side(value, valueName);
			this.setState({ [valueName]: value }, () => {
				this.sendOptions();
			});
		}
	};
	roundValue = (value) => {
		if (value % 5 !== 0) {
			return Math.round(value / 10) * 10;
		}
		else {
			return +value;
		}
	};
	sendOptions = () => {
		const { width, height, length } = this.state;
		if (width >= 20 && height >= 20 && length >= 20) {
			let dimensions = [];
			dimensions.push(this.roundValue(width), this.roundValue(height), this.roundValue(length));
			this.props.onChange(dimensions);
		}
	};
	
	render() {
		const { title, className } = this.props;
		const { maxLength, message } = this.state;
		
		if (!title) return null;
		const fields = title.split('X').map(el => el.trim());
		const titles = fields.map(el => el[0].toUpperCase() + el.slice(1));
		const rowWidth = 24;
		const colWidth = rowWidth / fields.length;
		const options = fields.map((el, i) => {
			let error = el ? `${el}Error` : null;
			return <Col span={colWidth} key={el}>
				<Flexbox flexDirection="column" alignItems="flex-start">
					<label>{`${titles[i]}, cm`}</label>
					<Input value={this.state[el]}
					       id={el}
					       maxLength={maxLength}
					       onChange={this.onChange}
					       placeholder={`${titles[i]}, cm`}/>
					<div className={`errorBottom ${ this.state[error] ? ' displayErrorBottom' : null }`}>{message}</div>
				</Flexbox>
			</Col>;
		});
		
		return (
			<div className={className}>
				<InputGroup size='default'>
					{options}
				</InputGroup>
			</div>
		);
	}
};

export default injectIntl(TypeDimensions);



// WEBPACK FOOTER //
// ./src/components/AnswerTypeDimensions/TypeDimensions.js